export default "__VITE_ASSET__DNgi5Awj__"